<script lang="ts" setup>
import MasterLayout from "@/app/layouts/MasterLayout.vue";
import VToaster from "@/shared/ui/common/VToaster.vue";
</script>

<template>
  <MasterLayout />
  <VToaster />
</template>
